import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Starts each page at the top. Keyed on the path alone: opening a room panel
 * or running a search only changes the query string, and jumping the list to
 * the top then lost the guest's place when they closed the panel.
 */
const ScrollFixToTop = (props) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return <>{props.children}</>;
};

export default ScrollFixToTop;
